// apiService.js
import api from '../config/axiosConfig'; // your current axios setup

const isFormData = (data) => {
    return data instanceof FormData;
};

const apiService = {
    get: async (url, params = {}, config = {}) => {
        return api.get(url, { params, ...config });
    },

    post: async (url, data = {}, config = {}) => {
        const headers = isFormData(data)
            ? { 'Content-Type': 'multipart/form-data' }
            : {};

        return api.post(url, data, {
            ...config,
            headers: { ...headers, ...(config.headers || {}) },
        });
    },

    put: async (url, data = {}, config = {}) => {
        const headers = isFormData(data)
            ? { 'Content-Type': 'multipart/form-data' }
            : {};

        return api.put(url, data, {
            ...config,
            headers: { ...headers, ...(config.headers || {}) },
        });
    },

    patch: async (url, data = {}, config = {}) => {
        return api.patch(url, data, config);
    },

    delete: async (url, config = {}) => {
        return api.delete(url, config);
    },

    customRequest: async (config) => {
        return api(config);
    }
};


export default apiService;
